import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {AccrualDocument, AccrualDocumentsSearchParams} from '@accounting/_common/models/accrual-document.models';

export const CheckState = createAction(
    '[AccrualDocuments] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: AccrualDocument[] } }>()
);

export const CheckStateSuccess = createAction(
    '[AccrualDocuments] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: AccrualDocument[] } }>()
);

export const LoadList = createAction(
    '[AccrualDocuments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[AccrualDocuments] Load List Success',
    props<{ payload: { items: AccrualDocument[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[AccrualDocuments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[AccrualDocuments] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[AccrualDocuments] Set Filter',
    props<{ payload: AccrualDocumentsSearchParams }>()
);

export const SetLoading = createAction(
    '[AccrualDocuments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[AccrualDocuments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[AccrualDocuments] Update Item Success',
    props<{ payload: AccrualDocument }>()
);

export const DeleteItem = createAction(
    '[AccrualDocuments] Delete Item',
    props<{ payload: AccrualDocument }>()
);

export const DeleteItemSuccess = createAction(
    '[AccrualDocuments] Delete Item Success',
    props<{ payload: AccrualDocument }>()
);

export const DeleteItemFailure = createAction(
    '[AccrualDocuments] Delete Item Failure',
    props<{ payload: AccrualDocument }>()
);

export const SetInitialState = createAction(
    '[AccrualDocuments] Set Initial State'
);
